module.exports = [
  require('./intersect'),
  require('./distance')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/geometry/index.js
// module id = 1206
// module chunks = 0